import React from "react";
import {
  Tools,
  ToolsItem,
  Tooltip,
} from "discover.medical.react-component-library";

const Toolbar = ({ tools, onToolClick }) => {
  // use currying to pass the tool in
  const handleToolClick = (tool) => (evt) => {
    if (onToolClick) {
      onToolClick(evt, tool);
    }
  };

  // wrap tools in tooltip component
  return (
    <Tools>
      {tools?.map((tool) => (
        <Tooltip
          key={tool.action}
          position="center"
          content={tool.hoverText}
          trigger={
            <ToolsItem
              color={tool.color}
              data-testid={tool.testId}
              glyph={tool.glyph}
              onClick={handleToolClick(tool)}
            >
              {tool.hoverText}
            </ToolsItem>
          }
        />
      ))}
    </Tools>
  );
};

Toolbar.displayName = "Toolbar";

export default Toolbar;
